import { StyleSheet } from "react-native";
import { Theme } from "../theme-provider";
import { colors } from "../../utils";

const detailsContentStyle = (theme: Theme) => StyleSheet.create({
    container: {
        paddingLeft: theme.spacing.sides,
        paddingRight: theme.spacing.sides,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: theme.spacing.sliver,
    },
    difficultyIcon: {
        width: theme.iconSize.medium,
        height: theme.iconSize.medium,
        marginRight: theme.spacing.half,
    },
    graphInfo: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: theme.spacing.half,
    },
    arrowIcon: {
        color: theme.color.textLink,
        width: theme.iconSize.small,
        height: theme.iconSize.small,
        marginLeft: theme.spacing.half,
        marginRight: theme.spacing.half,
    },
    leftGraphText: {
        width: '20%',
        textAlign: 'left',
    },
    rightGraphText: {
        width: '20%',
        textAlign: 'right',
    },
    share: {
        paddingLeft: theme.spacing.standard,
        marginLeft: 'auto',
        marginBottom: 'auto',
    },
    shareIcon: {
        color: theme.color.textLink,
        width: theme.iconSize.large,
        height: theme.iconSize.large,
        marginLeft: theme.spacing.half,
    },
    secondaryHeader: {
        flexShrink: 1,
        flexWrap: 'wrap',
    },
    paragraph: {
        paddingBottom: theme.spacing.standard,
    },
    capitalize: {
        textTransform: 'capitalize',
    },
    standard: {
        fontSize: theme.fontSize.standard,
    },
    medium: {
        fontSize: theme.fontSize.medium,
    },
    link: {
        color: theme.color.textLink,
    },
    underLine: {
        textDecorationLine: 'underline',
    },
    primary: {
        color: theme.color.textPrimary,
    },
    secondary: {
        color: theme.color.textSecondary,
    },
    imagesContainer: {
        paddingLeft:theme.spacing.sides,
    },
    separatorLine: {
        borderTopColor: colors.neutralColor50,
        borderTopWidth: theme.units.base * 0.1,
        paddingTop: theme.spacing.standard,
        paddingBottom: theme.spacing.standard
    },
    iconWrapper: {
        padding: theme.spacing.half,
    },
    compositeDropdownWrapper: {
        marginBottom: theme.spacing.sliver,
        alignItems: 'flex-start',
        zIndex: 20,
    },
    compositeDropdownHeaderRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    compositeDropdownToggle: {
        width: 18,
        height: 14,
        borderRadius: 3,
        backgroundColor: theme.color.mapIcons,
        borderWidth: 1,
        borderColor: theme.color.mapIcons,
        alignItems: 'center',
        justifyContent: 'center',
        shadowColor: '#000',
        shadowOpacity: 0.18,
        shadowRadius: 2,
        shadowOffset: { width: 0, height: 1 },
        elevation: 12,
    },
    compositeDropdownLabel: {
        marginLeft: theme.spacing.half,
        fontSize: theme.fontSize.medium,
        color: theme.color.textPrimary,
    },
    compositeDropdownList: {
        marginTop: theme.spacing.sliver,
        marginLeft: 0,
        backgroundColor: theme.color.background,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: colors.neutralColor50,
        width: '76%',
        maxWidth: 300,
        overflow: 'hidden',
        shadowColor: '#000',
        shadowOpacity: 0.08,
        shadowRadius: 2,
        shadowOffset: { width: 0, height: 1 },
        elevation: 1,
    },
    compositeDropdownItem: {
        paddingHorizontal: theme.spacing.half + theme.spacing.standard,
        paddingVertical: theme.spacing.half,
        borderBottomWidth: 1,
        borderBottomColor: colors.neutralColor50,
    },
    compositeDropdownItemText: {
        fontSize: theme.fontSize.standard,
        color: theme.color.textPrimary,
    },
    compositeDropdownItemLast: {
        borderBottomWidth: 0,
    },
    compositeParentWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: theme.spacing.half,
    },
    compositeParentConnector: {
        width: 14,
        height: 16,
        borderLeftWidth: 2,
        borderBottomWidth: 2,
        borderColor: theme.color.textPrimary,
        marginRight: theme.spacing.half,
        marginLeft: 2,
        marginTop: -10,
    },
    compositeParentText: {
        fontSize: theme.fontSize.medium,
        color: theme.color.textPrimary,
        marginTop: 3,
    },
    expandButtonIcon: {
        color: theme.color.background,
    },
    expandIcon: {
        transform: [{ rotate: '0deg' }],
    },
    expandIconExpanded: {
        transform: [{ rotate: '180deg' }],
    },
});

export { detailsContentStyle }